export default "__VITE_PUBLIC_ASSET__4d795242__"